// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1qEnV","col":"styles_col__4lAda"};